import { memo } from "react";
import { Modal } from "react-bootstrap";
import "./custom-components.style.scss";
import PropTypes from "prop-types";

const CustomModal = (props) => {
  const {
    modalOpen,
    modalHide,
    closeBtn,
    modalCustomClass,
    modalBody,
    closeBtnFuc,
    downloadBtn,
    downloadFuc,
    size,
    Modalsize,
    customModelClassName,
    customCloseBtnClass,
  } = props;
  return (
    <Modal
      show={modalOpen}
      onHide={modalHide}
      centered
      dialogClassName={modalCustomClass}
      animation={true}
      size={size}
      backdrop="static"
      className={Modalsize}
    >
      <div className="d-flex justify-content-end align-items-center">
        {downloadBtn && <button className="solid-btn mx-5 mt-2" onClick={downloadFuc}>Download</button>}
        {closeBtn && <button type="button" className={`${customCloseBtnClass ? customCloseBtnClass :"btn-close"}`} data-bs-dismiss="modal" aria-label="Close" onClick={() => closeBtnFuc()}>×</button>}
      </div>
      <Modal.Body className = {customModelClassName}>{modalBody()}</Modal.Body>
    </Modal>
  );
};
CustomModal.propTypes = {
  modalOpen: PropTypes.bool,
  modalHide: PropTypes.func,
  closeBtn: PropTypes.bool,
  closeBtnFuc: PropTypes.func,
  modalCustomClass: PropTypes.string,
  customCloseBtnClass: PropTypes.string,
  modalBody: PropTypes.func,
  downloadBtn: PropTypes.bool,
  downloadFuc: PropTypes.func,
  size: PropTypes.string,
  customModelClassName: PropTypes.string,
  Modalsize: PropTypes.string,
};

export default memo(CustomModal);
 